import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

const LINKS = {
  Company: [
    { label: "About Us", to: "/about" },
    { label: "Contact", to: "/contact" },
    { label: "Careers", to: "/careers" },
  ],
  Services: [
    { label: "Car Service", to: "/services" },
    { label: "Subscriptions", to: "/subscriptions" },
    { label: "Book Now", to: "/book" },
  ],
  Support: [
    { label: "Help Center", to: "/contact" },
    { label: "Complaints", to: "/complaints" },
    { label: "Privacy Policy", to: "/privacy" },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-neutral-900 text-neutral-300 hidden md:block">
      <div className="container-app py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div>
            <div className="mb-4">
              <img
                src="/dm_logo-2-updated.png"
                alt="MechOnGo Automobiles"
                className="h-20 w-auto"
              />
            </div>
            <p className="text-sm text-neutral-400 mb-4">
              Premium car service at your doorstep. Quality you can trust.
            </p>
            <div className="space-y-2 text-sm">
              <a
                href="tel:+917618333311"
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <Phone size={14} className="text-primary-400 shrink-0" />
                <span>+91 76183 33311</span>
              </a>
              <a
                href="mailto:info@mechongo.com"
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <Mail size={14} className="text-primary-400 shrink-0" />
                <span>info@mechongo.com</span>
              </a>
              <a
                href="https://maps.google.com/?q=New+Delhi,India"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-primary-400 transition-colors"
              >
                <MapPin size={14} className="text-primary-400 shrink-0" />
                <span>New Delhi, India</span>
              </a>
            </div>
          </div>

          {/* Link columns */}
          {Object.entries(LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-semibold text-white mb-3 text-sm">{title}</h4>
              <ul className="space-y-2">
                {links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-neutral-400 hover:text-primary-400 transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <hr className="border-neutral-800 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-neutral-500">
          <p>
            &copy; {new Date().getFullYear()} MechOnGo Automobiles. All rights
            reserved.
          </p>
          <div className="flex items-center gap-4">
            <Link to="/terms" className="hover:text-neutral-300">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-neutral-300">
              Privacy
            </Link>
            <Link to="/refund" className="hover:text-neutral-300">
              Refund Policy
            </Link>
            <span className="text-neutral-700">|</span>
            <div className="flex items-center gap-2">
              <span className="text-xs text-neutral-500">Powered by</span>
              <img
                src="/haytham-tech-logo.png"
                alt="Haytham Tech Solutions"
                className="h-7 w-auto opacity-80 hover:opacity-100 transition-opacity"
              />
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
